var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvailableSlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 103,
    viewBox: "0 0 141 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.7354 32.8848H64.0371V51H53.5781V0.619141H75.5215C80.5801 0.619141 84.6133 1.91797 87.6211 4.51562C90.6289 7.11328 92.1328 11.1351 92.1328 16.5811C92.1328 22.5283 90.6289 26.7324 87.6211 29.1934C84.6133 31.6543 80.318 32.8848 74.7354 32.8848ZM79.6572 22.3916C81.0244 21.1839 81.708 19.2699 81.708 16.6494C81.708 14.029 81.013 12.1605 79.623 11.0439C78.2559 9.92741 76.3304 9.36914 73.8467 9.36914H64.0371V24.2031H73.8467C76.3304 24.2031 78.2673 23.5993 79.6572 22.3916Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.925 41.0854L141 103H0L30.0632 41.0854H36.7293C38.5099 44.0332 40.3842 46.8889 42.3268 49.5699H35.3312L13.5003 94.5182H127.487L105.662 49.5699H98.667C100.609 46.9078 102.483 44.0523 104.257 41.0854H110.925Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableSlot);
export default __webpack_public_path__ + "static/media/availableSlot.ed626d0034059fd015acf471596e3a06.svg";
export { ForwardRef as ReactComponent };